import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Mark } from "./Mark";
import { scrollToId } from "./lenis";
import { mailto } from "../../content";

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact" },
  { id: "about", label: "About" },
];

export const NavLink = ({ id, label, testid, className = "" }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <a
      href={`/#${id}`}
      data-testid={testid}
      onClick={(e) => {
        e.preventDefault();
        if (pathname === "/") scrollToId(id);
        else navigate(`/#${id}`);
      }}
      className={`link-underline ${className}`}
    >
      {label}
    </a>
  );
};

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 border-b ${
        scrolled ? "bg-[#0F161E]/75 backdrop-blur-xl border-[#B59A5B]/20" : "bg-transparent border-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between gap-4" aria-label="Primary">
        <NavLink
          id="home"
          testid="nav-logo"
          label={
            <span className="flex items-center gap-2.5 text-[#C9AD6A]">
              <Mark className="w-7 h-7 sm:w-8 sm:h-8" />
              <span className="font-display tracking-[0.28em] text-[13px] sm:text-sm text-[#FAF6ED] hidden min-[420px]:inline">10THCELESTIAL</span>
            </span>
          }
          className="no-underline-fx"
        />
        <div className="flex items-center gap-4 sm:gap-9 font-caps text-[11px] sm:text-xs tracking-[0.22em] uppercase text-[#FAF6ED]/85">
          {NAV_LINKS.map((l) => (
            <NavLink key={l.id} id={l.id} label={l.label} testid={`nav-link-${l.id}`} className="hover:text-[#E2CC92] transition-colors" />
          ))}
          <a
            href={mailto("Consultation inquiry")}
            data-testid="nav-cta-inquire"
            className="hidden md:inline-flex items-center rounded-full border border-[#B59A5B]/60 px-5 py-2.5 text-[#E2CC92] hover:bg-[#B59A5B] hover:text-[#131B24] transition-colors duration-300"
          >
            Inquire
          </a>
        </div>
      </nav>
    </header>
  );
};
